import { toCamelCase } from '@cli-utils/text.js'
export function createSnippetImportName(snippetId: string): string {
  return `${toCamelCase(snippetId)}Snippet`
}
